module.exports = __webpack_public_path__ + "static/media/wavebg.6c1dfd64.svg";